export const root =
  typeof document !== 'undefined' ? document.getElementById('___gatsby') : null

export const isBrowser = typeof window !== 'undefined'
